module.exports = __webpack_public_path__ + "img/jorg_reinhold.cede0ad5.jpg";